import React from "react";
import { Skeleton } from "@/components/ui";

export function LoadingState() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-3">
        <Skeleton className="size-10 rounded-full" />
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-40" />
        </div>
      </div>
      <Skeleton className="h-[450px] w-full rounded-2xl" />
    </div>
  );
}
